export const industryReducer = (state = {  }, action) => {
    switch(action.type){
        case 'GET_INDUSTRY_PENDING':
            return { loading: true } 
        case 'GET_INDUSTRY_SUCCESS':
            return { loading: false, industries: action.payload }
        case 'GET_INDUSTRY_FAILED':
            return {loading:false, error: action.payload}
        default:
            return state
    }

}